import { render } from "./NoteDialog.vue?vue&type=template&id=7f6bbb68&scoped=true"
import script from "./NoteDialog.vue?vue&type=script&lang=js"
export * from "./NoteDialog.vue?vue&type=script&lang=js"

import "./NoteDialog.vue?vue&type=style&index=0&id=7f6bbb68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6bbb68"]])

export default __exports__